export class Organization {
    id: number;         // Unique identifier for the organization
    organizationName: string;      
    primaryContact: string;   
    description: string;   
    status?: number; 
    city?: string;     
    province?:string;
    country?:string;
    postalCode?:string;
    primaryPhone:string;
    organizationId: string = '1'; // Default value set to '1'
    companyId?:number;//main comany id
    createdDateTime: string;
    email:string;
    message:string;
  }
  export class SessionTimeout {
    organizationId: number;         // Organization ID
    roleId: number;                 // Role ID (e.g., Super Admin, Admin, etc.)
    timeout: number;                // Timeout value in minutes
    status: boolean;                // Indicates if the session timeout is active or not
  }
  